import { render, staticRenderFns } from "./PdfReportUpload.vue?vue&type=template&id=51ed3415&scoped=true"
import script from "./PdfReportUpload.vue?vue&type=script&lang=js"
export * from "./PdfReportUpload.vue?vue&type=script&lang=js"
import style0 from "./PdfReportUpload.vue?vue&type=style&index=0&id=51ed3415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed3415",
  null
  
)

export default component.exports